export default __webpack_public_path__ + "static/media/gallery-img-8.dd51d8ba.jpg";